<div *ngIf="isResponseAvailable">
  <div class="title">
    <div class="page-title">{{ 'MGMT_LIST.Check_Questions' | translate }}</div>
    <span *ngIf="response.status === 'inProgress'" class="complete-percent-value">( {{ questionCompletedPercent }}% {{ 'SHARED.Complete' | translate }} )</span>
    <span *ngIf="response.status === 'complete'" class="complete-percent-value">( {{ 'SHARED.Duration' | translate }} - {{ duration }} )</span>
  </div>

  <app-data-table [dataTableOptions]="dataTableOptions"></app-data-table>
</div>

<div *ngIf="externalPanel" class="external-panel">
  <div class="title">
    <div class="page-title">{{ 'SHARED.Performed_In_MaintainX' | translate }}</div>
  </div>
  <dl class="external-details">
    <dt>{{ 'SHARED.MaintainX_Work_Order' | translate }}</dt>
    <dd>{{ externalPanel.workOrder }}</dd>
    <dt>{{ 'SHARED.MaintainX_Completed_At' | translate }}</dt>
    <dd>{{ externalPanel.completedAt }}</dd>
    <dt>{{ 'SHARED.MaintainX_Completed_By' | translate }}</dt>
    <dd>{{ externalPanel.completedBy }}</dd>
    <ng-container *ngIf="externalPanel.score">
      <dt>{{ 'SHARED.MaintainX_Score' | translate }}</dt>
      <dd>{{ externalPanel.score }}</dd>
    </ng-container>
  </dl>
  <ng-container *ngIf="externalPanel.fields.length">
    <div class="external-fields-title">{{ 'SHARED.MaintainX_Fields' | translate }}</div>
    <dl class="external-details">
      <ng-container *ngFor="let field of externalPanel.fields">
        <dt>{{ field.label }}</dt>
        <dd>{{ field.value }}</dd>
      </ng-container>
    </dl>
  </ng-container>
</div>
